import { render, staticRenderFns } from "./DisplayIcon.vue?vue&type=template&id=cdb8b53c&scoped=true&"
import script from "./DisplayIcon.vue?vue&type=script&lang=js&"
export * from "./DisplayIcon.vue?vue&type=script&lang=js&"
import style0 from "./DisplayIcon.vue?vue&type=style&index=0&id=cdb8b53c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb8b53c",
  null
  
)

export default component.exports